import type {BrandKitWithAssets} from "@Components/mystuff-brands/brand-kits.types";
import {useSortedBrandKitsWithAssets} from "@Hooks/brands/useSortedBrandKitsWithAssets";
import {doesBrandHaveAnyAssetType, doesBrandHaveColorsOrFonts} from "@Libraries/brands-library";

export const useFilterUsableBrandKits = (includeImagesInFilter: boolean = true): BrandKitWithAssets[] => {
    const brandKitsWithAssets = useSortedBrandKitsWithAssets();
    return brandKitsWithAssets.filter((brandInfo) => {
        return includeImagesInFilter ? doesBrandHaveAnyAssetType(brandInfo.brandKit.brandId) : doesBrandHaveColorsOrFonts(brandInfo.brandKit.brandId);
    });
};